export type CardSize = 'small' | 'medium' | 'large';

export function getImgSizes(size = 'small') {
  switch (size) {
    case 'large': {
      return `
        (max-width: 600px) 800px,
        1200px
      `;
    }
    default: {
      return `
        (max-width: 600px) 400px,
        800px
      `;
    }
  }
}

export function getImgSrcSet(size = 'small', imageUrls: any) {
  switch (size) {
    case 'large': {
      return `
        ${imageUrls['800px']} 800w,
        ${imageUrls['1200px']} 1200w
      `;
    }
    default: {
      return `
        ${imageUrls['400px']} 400w,
        ${imageUrls['800px']} 800w
      `;
    }
  }
}

export function getAspectRatio(size = 'small') {
  switch (size) {
    case 'small': {
      return 1;
    }
    case 'medium': {
      return 1.02; // fudging it slightly to fit the templates
    }
    case 'large': {
      return 0.67;
    }
    default: {
      return 1;
    }
  }
}
